<template>
	<div class="print-layout min-h-screen bg-gray-100">

		<div class="print-page bg-white mx-auto">
			<slot />
		</div>

		<div class="print:hidden fixed bottom-6 right-6">
			<button class="btn btn-primary shadow-lg" @click="print">
				<PrinterIcon class="w-5 h-5" />
				{{ $t('Print') }}
			</button>
		</div>

	</div>
</template>

<style>
@media screen {
	.print-page {
		max-width: 21cm;
		padding: 2cm;
		min-height: 29.7cm;
		box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
		margin-top: 2rem;
		margin-bottom: 2rem;
	}
}

@media print {
	@page {
		size: A4;
		margin: 1.5cm;
	}

	html,
	:root {
		background: none;
	}

	html,
	body {
		-webkit-print-color-adjust: exact;
		print-color-adjust: exact;
		margin: 0;
	}

	.print-layout {
		background: white;
		min-height: unset;
	}

	.print-page {
		padding: 0;
		box-shadow: none;
		margin: 0;
	}
}
</style>

<script lang="ts">
import { PrinterIcon } from "@heroicons/vue/24/outline";

export default {
	name: 'ThePrintLayout',

	components: {
		PrinterIcon,
	},

	methods: {
		print() {
			window.print();
		},
	},
};
</script>
